module.exports = __webpack_public_path__ + "img/EJCMID_cover.4f1b1a3b.jpg";